<div class="modal-header scroll-shadow-top" ngbAutofocus>
  <div class="modal-content__header">
    <!-- Bug: Scrolling does not reach the correct progress stepper if content is short -->
    <div class="modal-content__header__progress-container">
      <div class="modal-content__stepper-container">
        <div
          class="modal-content__stepper-container__stepper-bar"
          [style.width]="stepperWidth + '%'"
        ></div>
      </div>
    </div>

    <div class="modal-content__steppers">
      <div *ngFor="let content of tncContent; let i = index">
        <div
          class="modal-content__steppers__text"
          [class.active]="activeStep >= i"
          (click)="scrollTo(i)"
        >
          <div class="stepper-circle">
            {{ i + 1 }}
          </div>
          <div class="stepper-title">{{ content.title }}</div>
        </div>
      </div>
      <!--      <div (click)="scrollTo('content_body_1')">Purpose of this form</div>-->
      <!--      <div (click)="scrollTo('content_body_2')">Important notice</div>-->
      <!--      <div (click)="scrollTo('content_body_3')">Risk and liabilities</div>-->
    </div>
  </div>
</div>
<div
  class="modal-body"
  appScrollSpy
  [componentRef]="modalNextBtn"
  #multiStepModalBody
>
  <div
    *ngFor="let content of tncContent; let i = index"
    class="content-container"
    #contentContainer
  >
    <div class="modal-section-title">
      {{ content.title }}
    </div>
    <div [innerHTML]="content.body" class="managed-content"></div>
  </div>
</div>
<div class="modal-footer scroll-shadow-bottom">
  <app-primary-button
    (click)="onClickClose()"
    [disabled]="scrollPercentage < 98"
    #modalNextBtn
  >
    Next
  </app-primary-button>
</div>
